(function() {
    'use strict';

    angular
        .module('app.procesosMasivos')
        .run(appRun);

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/procesar-masivo',
                config: {
                    templateUrl: 'app/procesosMasivos/procesarMasivo.html',
                    controller: 'ProcesarMasivo',
                    controllerAs: 'vm',
                    title: 'ProcesarMasivo'
                }
            },
            {
                url: '/procesos-masivos/:id?',
                config: {
                    templateUrl: 'app/procesosMasivos/procesosMasivos.html',
                    controller: 'ProcesosMasivos',
                    controllerAs: 'vm',
                    title: 'ProcesosMasivos'
                }
            },
            {
                url: '/proceso-masivo-detalle/:companiaId/:encabezadoId',
                config: {
                    templateUrl: 'app/procesosMasivos/procesoMasivoDetalle.html',
                    controller: 'ProcesoMasivoDetalle',
                    controllerAs: 'vm',
                    title: 'ProcesoMasivoDetalle'
                }
            }               
        ];
    }
})();
